<template>
  <div class="login">
    <div class="login-form">
      <div class="title">{{ getTitle('login.userLogin') }}</div>
      <el-form :model="loginForm" ref="loginForm">
        <el-form-item
          prop="phone"
          :rules="[
            { required: true, message: getTitle('login.phoneNone') },
            { type: 'number', message: getTitle('login.phoneError') },
          ]"
        >
          <el-input
            type="phone"
            v-model.number="loginForm.phone"
            autocomplete="off"
            :placeholder="getTitle('login.phoneInput')"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="auth"
          :rules="[
            { required: true, message: getTitle('login.verifyCodeNone') },
            { type: 'number', message: getTitle('login.verifyCodeError') },
          ]"
        >
          <el-row>
            <el-col :span="16">
              <el-input
                type="auth"
                v-model.number="loginForm.auth"
                autocomplete="off"
                :placeholder="getTitle('login.verifyCodeInpnt')"
                @keyup.enter.native="submitForm('loginForm')"
              ></el-input>
            </el-col>
            <el-col :span="8" class="btn-send">
              <el-button
                type="success"
                circle
                @click="getCode()"
                :disabled="btnChangeEnable"
              >
                <span v-if="isArrowShow">{{
                  getTitle('login.verifyCode')
                }}</span>
                <span v-else>{{ codeText }}</span>
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('loginForm')">{{
            getTitle('login.login')
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="login-qrcode">
      <div class="title">{{ getTitle('login.fasterWay') }}</div>
      <div class="content">
        <div class="left">
          <div class="border">
            <div class="name">{{ getTitle('login.wechatTicket') }}</div>
            <img src="../assets/images/qrcode.png" />
          </div>
          <p>
            {{ getTitle('login.wechatScan') }}<br />{{
              getTitle('login.buyTicket')
            }}
          </p>
        </div>
        <div class="right">
          <div class="border">
            <div class="name">{{ getTitle('login.appTicket') }}</div>
            <img src="../assets/images/qrcode.png" />
          </div>
          <p>
            {{ getTitle('login.wechatScan') }}<br />{{
              getTitle('login.downloadApp')
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import base from '../api/base';
import user from '../setup/user';
import routerTo from '../router/routerTo';
import { regexs } from '../setup/common';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      loginForm: {
        phone: '',
        auth: '',
      },
      uuid: '',
      codeText: '',
      isArrowShow: true,
      btnChangeEnable: false,
      code: {
        btn: false,
        intervalId: null,
      },
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
  },
  async created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    ...mapMutations(['setIsLogin', 'setLoginPhone']),
    async submitForm(formName) {
      if (this.loginForm.phone.length == 0) {
        alert(this.getTitle('login.phoneInput'));
        return;
      }
      if (!regexs.allphone.test(this.loginForm.phone)) {
        alert(this.getTitle('login.phoneError'));
        return;
      }
      if (this.loginForm.auth.length == 0) {
        alert(this.getTitle('login.verifyCodeInpnt'));
        return;
      }
      const loginDetail = await base.getCheckSmsAuthCode({
        uuid: this.uuid,
        auth_code: this.loginForm.auth,
        phone: this.loginForm.phone,
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
      });
      /*this.$store.commit('upDataLogin', true);*/
      // localStorage.setItem('isLogin', true);
      this.setIsLogin(true);
      this.setLoginPhone(this.loginForm.phone);
      user.setUser(
        loginDetail.usercode,
        loginDetail.sessionid,
        loginDetail.sessionid_expire,
        loginDetail.avatar,
        this.loginForm.phone,
      );
      /*routerTo.toTicketSellHome(this.$router, false);*/
      this.$router.go(-1);
      /*
      this.$refs[formName].valiate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!');
          return false;
        }
      });*/
    },
    async getCode() {
      if (this.loginForm.phone.length == 0) {
        alert(this.getTitle('login.phoneInput'));
        return;
      }
      let params = {
        phone: this.loginForm.phone,
        username: this.loginForm.phone,
      };
      const phoneCaptchaDetail = await base.getSysMessage(params);
      this.uuid = phoneCaptchaDetail.uuid;
      this.countDown();
      this.isArrowShow = false;
    },
    countDown() {
      let num = 60;
      this.code.intervalId = setInterval(() => {
        if (num) {
          num--;
          this.codeText = JSON.stringify(num);
          this.btnChangeEnable = true;
        } else {
          num = 60;
          clearInterval(this.code.intervalId);
          this.isArrowShow = true;
          this.btnChangeEnable = false;
        }
      }, 1000);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: url(../assets/images/bg-login.jpg) no-repeat 0 0;
  background-size: cover;
  .login-form {
    width: 320px;
    margin-right: 10px;
    padding: 40px 40px;
    border-radius: 10px;
    background: #fff;
    .title {
      margin-bottom: 40px;
      font-weight: bold;
      font-size: 18px;
    }
    .btn-send {
      line-height: 1;
      text-align: right;
    }
    .tips {
      height: 50px;
      padding-top: 20px;
      color: #31a775;
      text-align: center;
    }
  }
  .login-form /deep/ .el-input__inner {
    padding: 0 20px;
    border: none;
    border-radius: 20px;
    background: #eee;
  }
  .login-form /deep/ .el-input__inner::placeholder {
    color: #515457;
  }
  .login-form /deep/ .el-form-item__error {
    padding: 5px 20px 0;
    top: 40px;
  }
  .login-form /deep/ .el-button--success {
    width: 76px;
    padding: 10px 0;
    border: none;
    color: #31a775;
    font-weight: bold;
    line-height: 20px;
    background: none;
  }
  .login-form /deep/ .el-button--primary {
    width: 100%;
    margin-top: 24px;
    border-color: #31a775;
    border-radius: 20px;
    background-color: #31a775;
  }
  .login-qrcode {
    width: 670px;
    border-radius: 10px;
    background: #fff;
    .title {
      padding: 12px 0;
      border-radius: 10px 10px 0 0;
      color: #191b26;
      font-weight: bold;
      font-size: 18px;
      text-align: center;
      background: #eee;
    }
    .content {
      display: flex;
      justify-content: center;
      padding: 24px 0 24px;
      text-align: center;
      .left {
        margin: 0 30px;
        .border {
          margin-bottom: 10px;
          padding: 14px 24px;
          border: 2px solid #31a775;
          border-radius: 10px;
          .name {
            margin-bottom: 15px;
            padding-bottom: 10px;
            border-bottom: 1px dashed #eee;
          }
        }
      }
      .right {
        margin: 0 30px;
        .border {
          margin-bottom: 10px;
          padding: 14px 24px;
          border: 2px solid #599bf8;
          border-radius: 10px;
          .name {
            margin-bottom: 15px;
            padding-bottom: 10px;
            border-bottom: 1px dashed #eee;
          }
        }
      }
      img {
        width: 130px;
      }
    }
  }
}
</style>
